import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Chip,
  InputAdornment,
  Stack,
  TextField,
} from "@mui/material";
import { useState } from "react";

const MAX_URLS = 10;

const isValidUrl = (url) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

const FormikUrlInput = ({
  formikProps,
  name = "links",
  placeholder = "Paste URL and press Enter",
}) => {
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState("");

  const urls = formikProps.values[name] || [];

  const handleAddUrl = () => {
    const trimmed = inputValue.trim();

    if (!trimmed) return;

    if (!isValidUrl(trimmed)) {
      setError("Invalid URL");
      return;
    }

    if (urls.includes(trimmed)) {
      setError("URL already added");
      return;
    }

    if (urls.length >= MAX_URLS) {
      setError(`Maximum ${MAX_URLS} URLs allowed`);
      return;
    }

    formikProps.setFieldValue(name, [...urls, trimmed]);
    setInputValue("");
    setError("");
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleAddUrl();
    }
  };

  const handleDelete = (urlToDelete) => {
    const updated = urls.filter((url) => url !== urlToDelete);
    formikProps.setFieldValue(name, updated);
  };

  return (
    <Box>
      <TextField
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value);
          setError("");
        }}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Button variant="contained" size={"small"} onClick={handleAddUrl}>
                Add URL
              </Button>
            </InputAdornment>
          ),
        }}
        error={!!error}
        helperText={error}
      />

      <Stack direction="row" spacing={1} mt={2} flexWrap="wrap">
        {urls.map((url) => (
          <Chip
            key={url}
            onClick={() => {
              window.open(url, "_blank");
            }}
            label={url}
            onDelete={() => handleDelete(url)}
            deleteIcon={<CloseIcon fontSize="small" />}
            variant="outlined"
            sx={{
              backgroundColor: "#f0f0f0",
              fontSize: 14,
              opacity: 1,
              border: "none",
            }}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default FormikUrlInput;
